/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { ofType } from "redux-observable"
import { concat, from, of, zip } from "rxjs"
import { catchError, concatMap, endWith, flatMap, map, mergeAll, mergeMap, startWith, switchMap, take } from "rxjs/operators"

import CONSTANTS from "../../assets/js/Constants"

// Lấy thông tin bảo trì của phương tiện
const LayThongTinBaoTri = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.BAO_TRI_PHUONG_TIEN.GET_BAO_TRI_PHUONG_TIEN_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []

            // Load danh sách nhà cung cấp bảo trì
            // const nccBaoTri = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.DANH_MUC_BAO_DUONG.GET_ALL}`)
            const nccBaoTri = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.DANH_MUC_BAO_DUONG.GET_DS_FULL}`)
            // Load danh sách việc bảo trì
            // const viecBaoTri = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.TODO_LIST.GET_ALL}`)
            const viecBaoTri = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.TODO_LIST.GET_DS_VIEC_FULL}`)
            // Load thông tin bảo trì
            const thongTinBaoTri = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.BAO_TRI_PHUONG_TIEN.GET_BAO_TRI_PHUONG_TIEN}?vehicle_id=${action.payload.vehicle_id}&page=1`
            )

            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.BAO_TRI_PHUONG_TIEN.SET_BAO_TRI_PHUONG_TIEN_BY_NCC, nccBaoTri.data.data))
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.BAO_TRI_PHUONG_TIEN.SET_BAO_TRI_PHUONG_TIEN_BY_DS_VIEC, viecBaoTri.data.data))
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.BAO_TRI_PHUONG_TIEN.SET_BAO_TRI_PHUONG_TIEN_BY_ID, thongTinBaoTri.data.data))
			return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Cập nhật thông tin bảo trì
const CapNhatThongTinBaoTri = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.BAO_TRI_PHUONG_TIEN.PUT_BAO_TRI_PHUONG_TIEN),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            if (action.payload.start_date_time_cycle)
               action.payload.start_date_time_cycle = CONSTANTS.FUNCTION.COMMON.formatDate(action.payload.start_date_time_cycle, "DD/MM/YYYY")
            //if (action.payload.expired_date) action.payload.expired_date = CONSTANTS.FUNCTION.COMMON.formatDate(action.payload.expired_date, "DD/MM/YYYY")
			if (action.payload.next_maintain_date) action.payload.next_maintain_date = CONSTANTS.FUNCTION.COMMON.formatDate(action.payload.next_maintain_date, "DD/MM/YYYY")	

            const updateInfomation = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.BAO_TRI_PHUONG_TIEN.PUT_BAO_TRI_PHUONG_TIEN, action.payload)
            updateInfomation.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateInfomation.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateInfomation.data.mess))

            // Load thông tin bảo trì
            const thongTinBaoTri = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.BAO_TRI_PHUONG_TIEN.GET_BAO_TRI_PHUONG_TIEN}?vehicle_id=${action.payload.vehicle_id}&page=1`
            )
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.BAO_TRI_PHUONG_TIEN.SET_BAO_TRI_PHUONG_TIEN_BY_ID, thongTinBaoTri.data.data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Thêm mới thông tin bảo trì
const ThemMoiThongTinBaoTri = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.BAO_TRI_PHUONG_TIEN.POST_BAO_TRI_PHUONG_TIEN),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            if (action.payload.start_date_time_cycle)
               action.payload.start_date_time_cycle = CONSTANTS.FUNCTION.COMMON.formatDate(action.payload.start_date_time_cycle, "DD/MM/YYYY")
            //if (action.payload.expired_date) action.payload.expired_date = CONSTANTS.FUNCTION.COMMON.formatDate(action.payload.expired_date, "DD/MM/YYYY")
			if (action.payload.next_maintain_date) action.payload.next_maintain_date = CONSTANTS.FUNCTION.COMMON.formatDate(action.payload.next_maintain_date, "DD/MM/YYYY")		

            const postTransportation = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.BAO_TRI_PHUONG_TIEN.POST_BAO_TRI_PHUONG_TIEN, action.payload)
            postTransportation.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, postTransportation.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, postTransportation.data.mess))

            // Load thông tin bảo trì
            const thongTinBaoTri = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.BAO_TRI_PHUONG_TIEN.GET_BAO_TRI_PHUONG_TIEN}?vehicle_id=${action.payload.vehicle_id}&page=1`
            )
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.BAO_TRI_PHUONG_TIEN.SET_BAO_TRI_PHUONG_TIEN_BY_ID, thongTinBaoTri.data.data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API xóa bảo trì phương tiện
const XoaThongTinBaoTri = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.BAO_TRI_PHUONG_TIEN.DELETE_BAO_TRI_PHUONG_TIEN),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.BAO_TRI_PHUONG_TIEN.DELETE_BAO_TRI_PHUONG_TIEN, action.payload)

            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteTransportation.data.status))
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteTransportation.data.mess))

            // Load thông tin bảo trì
            const thongTinBaoTri = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.BAO_TRI_PHUONG_TIEN.GET_BAO_TRI_PHUONG_TIEN}?vehicle_id=${action.payload.vehicle_id}&page=1`
            )
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.BAO_TRI_PHUONG_TIEN.SET_BAO_TRI_PHUONG_TIEN_BY_ID, thongTinBaoTri.data.data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

export default {
   LayThongTinBaoTri,
   CapNhatThongTinBaoTri,
   ThemMoiThongTinBaoTri,
   XoaThongTinBaoTri
}
